import { useEffect, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";

import { showSuccessToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";
import { crmScopeOptionMap } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import type { RootState } from "single-spa/store/types";

import { selectFiltersValue } from "../store/selectors";
import leadsSearchFiltersI18nKeys from "../utils/i18n";

export const useCrmScopeAutoSwitchNotification = (): void => {
    const dispatch = useDispatch();
    const crmScope = useSelector((state: RootState) => selectFiltersValue(state).leadsFilters?.crmScope);
    const prevCrmScopeRef = useRef(crmScope);

    useEffect(() => {
        const prevScope = prevCrmScopeRef.current;
        prevCrmScopeRef.current = crmScope;

        if (prevScope === crmScopeOptionMap.netNew && crmScope === crmScopeOptionMap.inCrm) {
            dispatch(showSuccessToast(translate(leadsSearchFiltersI18nKeys.crmScopeAutoSwitchToast)));
        }
    }, [crmScope, dispatch]);
};
